export function getDaysInSelectedMonthWithWeekday(month: number, year: number) {
  const allDaysInMonth = new Date(year, month + 1, 0).getDate();

  const allDays = [...new Array(allDaysInMonth + 1).keys()];
  allDays.splice(0, 1);

  const todaysDateReference = new Date();

  const todaysDateWithNoTime = new Date(
    todaysDateReference.getFullYear(),
    todaysDateReference.getMonth(),
    todaysDateReference.getDate()
  );

  return allDays.map(day => {
    const currentDate = new Date(year, month, day);
    return {
      day: day.toString(),
      weekDay: currentDate.toLocaleString("en", { weekday: "short" }),
      isBeforeToday: todaysDateWithNoTime > currentDate,
    };
  });
}

export function getXMonthsFromNow(numOfMonths: number) {
  const currentDate = new Date();
  const months: { month: number; year: number; label: string }[] = [];
  for (let i = 0; i < numOfMonths; i++) {
    const label = `${currentDate.toLocaleString("en", {
      month: "long",
    })}, ${currentDate.getFullYear()}`;
    const month = currentDate.getMonth();
    const year = currentDate.getFullYear();

    months.push({ month, year, label });
    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  return months;
}

export function isSameDay(d1: Date, d2: Date) {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}

export function getAge(dateOfBirth: Date) {
  if (!dateOfBirth || !dateOfBirth.getTime()) {
    return "";
  }
  const today = new Date();

  const yearDiff = today.getFullYear() - dateOfBirth.getFullYear();

  const monthDiff = today.getMonth() - dateOfBirth.getMonth();

  const isDateAndMonthOnOrAfter =
    today.getMonth() > dateOfBirth.getMonth() ||
    (today.getMonth() === dateOfBirth.getMonth() &&
      today.getDate() >= dateOfBirth.getDate());

  const ageInYears = isDateAndMonthOnOrAfter ? yearDiff : yearDiff - 1;

  return `${ageInYears}y${monthDiff > 0 ? `, ${monthDiff}m` : ""}`;
}

export function isDateInThePast(dateObj: Date) {
  const today = new Date();
  return dateObj.getTime() < today.getTime();
}

export const formatMobile = (mobileNumber: string) => {
  if (!mobileNumber.includes("+91")) {
    return mobileNumber;
  }
  return `+91-${mobileNumber.split("+91")[1]}`;
};

export const getNoOfDaysFromToday = (date: Date): number => {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  const today = new Date();
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const utc2 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
};
